import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Heading,
  Text,
  UnorderedList,
  ListItem,
} from '@chakra-ui/react';

import {useTranslate} from '@eksab/i18n';

import {fantasyRules, predictionsRules} from './';

interface RulesSectionProps {
  section: (typeof fantasyRules.sections)[number] | (typeof predictionsRules.sections)[number];
}

export const RulesSection = ({section: {heading, rules}}: RulesSectionProps) => {
  const t = useTranslate();

  return (
    <AccordionItem borderTop="none">
      <AccordionButton
        justifyContent="space-between"
        _expanded={{pb: 2}}
        py="7"
        ps="0"
        transition="padding 0.5s"
        _focus={{}}
      >
        <Heading fontSize={['md', null, 'xl']} textAlign="start">
          {t(heading)}
        </Heading>

        <AccordionIcon boxSize="8" />
      </AccordionButton>

      <AccordionPanel ps="0">
        {rules instanceof Array ? (
          <UnorderedList display="flex" flexDir="column" gap="3">
            {rules.map((rule) => (
              <ListItem key={rule} lineHeight="1.875" sx={{'&::marker': {fontSize: '0.5rem'}}}>
                {t(rule)}
              </ListItem>
            ))}
          </UnorderedList>
        ) : (
          <Text lineHeight="1.875">{t(rules)}</Text>
        )}
      </AccordionPanel>
    </AccordionItem>
  );
};
